import { Container } from './styled';
export function TextBalloon(props) {
    const { isUserSystem, text, ...res } = props;
    return (
        <Container isUserSystem={isUserSystem} {...res}>
            <p>
                {text}
            </p>
        </Container>
    );
}           